import { useRoutes } from "react-router-dom";
// components
import Layout from "../layout";
import Login from "src/pages/login";
import Cart from "../pages/cart/Cart";
import Welcome from "../pages/Welcome";
import Auth from "src/pages/login/Auth";
import Menu from "../pages/products-menu/Menu";
import MyOrders from "src/pages/orders/MyOrders";
import Schedule from "src/pages/Schedule";
import Chat from "src/pages/chat/Chat";
// import useResponsive from "../hooks/useResponsive";

export default function Router() {
  // const isDesktop = useResponsive('up', 'md');

  return useRoutes(
    [
      {
        path: "/",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Welcome />
          }
        ],
      },
      {
        path: "cardapio",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Menu />
          }
        ],
      },
      {
        path: "carrinho",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Cart />
          }
        ],
      },
      {
        path: "pedidos",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <MyOrders />
          }
        ],
      },
      {
        path: "login",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Login />
          }
        ],
      },
      {
        path: "auth",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Auth />
          }
        ],
      },
      {
        path: "horarios",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Schedule />
          }
        ],
      },
      {
        path: "chat",
        element: <Layout />,
        children: [
          {
            index: true,
            element: <Chat />
          }
        ],
      }
      // { path: '/', element: <Navigate to={"/gerenciador"} replace /> }
    ]
  );
}